import React from "react";
import { Card } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers"; //, checkIsActive
import {
  STATISTICS_CAP,
  TOTAL_ACTIVE_USERS_CAP,
  TOTAL_BUSINESS_USERS_CAP,
  TOTAL_INACTIVE_USERS_CAP,
  TOTAL_MAKE_A_PAYMENT_CAP,
  TOTAL_PAYMENT_REJECTED_REQUESTS_CAP,
  TOTAL_PENDING_BANK_CONFIRMATION_CAP,
  TOTAL_PENDING_REQUESTS_CAP,
  TOTAL_REFUND_REQUESTS_CAP,
  TOTAL_REQUEST_A_PAYMENT_CAP,
  TOTAL_TRANSACTIONS_CAP,
  TOTAL_TRANSACTION_WITH_SC_CAP,
  TOTAL_USERS_CAP,
  TOTAL_WITHDRAW_REQUESTS_CAP,
} from "../utils/const";
import NumberFormat from "react-number-format";

export function StatisticsCounter({ statisticsCounterList }) {
  const {
    total_transactions = "0",
    total_transactions_with_sc = "0",
    total_make_payment = "0",
    total_request_payment = "0",
    total_pending_request = "0",
    total_withdraw_request = "0",
    total_refund_request = "0",
    total_payment_rejected_request = "0",
    total_pending_bank_confirmation = "0",
    total_users = "0",
    total_business_users = "0",
    total_active_users = "0",
    total_inactive_users = "0",
  } = statisticsCounterList || {};

  const numberFormatter = (number) => {
    return (
      <NumberFormat
        value={number}
        displayType="text"
        thousandSeparator={true}
      />
    );
  };

  return (
    <>
      <div className="history-wrapper container dashboard-statistics">
        <div className="row">
          <div className="col-md-12">
            <div className="dashboard-header d-md-flex justify-content-md-between align-items-center">
              <div className="title d-none d-md-block">
                <h4 className="card-title align-items-center mb-3 mt-4">
                  <span className="card-label font-weight-bolder text-dark">
                    {STATISTICS_CAP}
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-transactions.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_transactions)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_TRANSACTIONS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/sc.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_transactions_with_sc)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_TRANSACTION_WITH_SC_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-4x svg-icon-warning menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/made-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_make_payment)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_MAKE_A_PAYMENT_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/request-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_request_payment)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_REQUEST_A_PAYMENT_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/pending-requested-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_pending_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_PENDING_REQUESTS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 d-none">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/withdraw-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_withdraw_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_WITHDRAW_REQUESTS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 d-none">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/refund-requests.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_refund_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_REFUND_REQUESTS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/payment-rejected-requests.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_payment_rejected_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_PAYMENT_REJECTED_REQUESTS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 d-none">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/pending-bank-confirmations.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_pending_bank_confirmation)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_PENDING_BANK_CONFIRMATION_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-business-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_users)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-business-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_business_users)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_BUSINESS_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/active-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_active_users)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_ACTIVE_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/inactive-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {numberFormatter(total_inactive_users)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_INACTIVE_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
